function CeckSStrg(){
  var sstrg = sessionStorage.getItem("alru");
  if(sstrg != null && sstrg != "null"){
    var ghrf =  window.location.href.split(".com/");
    window.location.href = ghrf[0] + ".com" + sstrg;
  };
  var CRTurl = new URL(window.location.href);
  var rstps = CRTurl.searchParams.get("rstps");
  if(rstps != null){
    document.getElementById("ss_lgi_pg_head_img-cntnt").setAttribute("data-lgin_top_cnt","rcvr");
  };
};

document.addEventListener("DOMContentLoaded", function () {
  CeckSStrg();
});

document.querySelectorAll(".ss_form_secound-action button[data-action='toggle-login-form']")[0].addEventListener("click", () => {
  /*document.querySelectorAll("form#customer_login")[0].setAttribute("style","display:none;");
  document.querySelectorAll(".ss_form_third_action[data-sslgn_actname='nwrgst']")[0].setAttribute("style","display:none;");
  document.querySelectorAll(".ss_form_third_action[data-sslgn_actname='tkqes']")[0].setAttribute("style","display:none;");
  document.querySelectorAll(".ss_form_secound-action")[0].setAttribute("style","display:none;");
  document.querySelectorAll(".container:has(iframe.one-click-social-login-buttons)")[0].setAttribute("style","display:none;");
  document.querySelectorAll("form#recover_customer_password")[0].setAttribute("style","display:block;");*/
  document.getElementById("ss_lgi_pg_head_img-cntnt").setAttribute("data-lgin_top_cnt","rcvr");
});

document.querySelectorAll(".form__secondary-action button.link.link--accented")[0].addEventListener("click", () => {
  /*document.querySelectorAll("form#customer_login")[0].setAttribute("style","block;");
  document.querySelectorAll(".ss_form_third_action[data-sslgn_actname='nwrgst']")[0].setAttribute("style","display:block;");
  document.querySelectorAll(".ss_form_third_action[data-sslgn_actname='tkqes']")[0].setAttribute("style","display:block;");
  document.querySelectorAll(".ss_form_secound-action")[0].setAttribute("style","display:block;");
  document.querySelectorAll(".container:has(iframe.one-click-social-login-buttons)")[0].setAttribute("style","display:block;");
  document.querySelectorAll("form#recover_customer_password")[0].setAttribute("style","display:none;");*/
  document.getElementById("ss_lgi_pg_head_img-cntnt").setAttribute("data-lgin_top_cnt","lgin");
});

document.querySelectorAll("#recover_customer_password button[type='submit']")[0].addEventListener("submit", (e) => {
  if (!this.checkValidity()) {
    e.preventDefault();
    this.reportValidity();
  }else{
    document.querySelectorAll(".rgs_sendmail_load_main")[0].setAttribute("data-rgssmt_load_disp","true");
  };
});